<template>
  <div>
    <div class="mask" v-if="visible" style="z-index: 900"></div>
    <transition name="confirm-scale">
      <div class="app-confirm" v-if="visible" style="z-index: 901">
        <div>{{message}}</div>
        <div>
          <a href="javascript:;" @click="onCancel">{{cancel}}</a>
          <a href="javascript:;" @click="onOK">{{ok}}</a>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        visible: false,
        message: '',
        ok: '',
        cancel: '',
        showTime: 0,
        promise: null
      }
    },
    methods: {
      show (message, {ok = '确定', cancel = '取消'} = {}) {
        this.message = message
        this.ok = ok
        this.cancel = cancel
        this.visible = true
        this.showTime = new Date().getTime()
        return new Promise((resolve, reject) => {
          this.promise = {resolve, reject}
        })
      },
      onCancel () {
        if (new Date().getTime() - this.showTime < 1000) {
          return
        }
        this.visible = false
        this.promise.resolve(false)
      },
      onOK () {
        if (new Date().getTime() - this.showTime < 1000) {
          return
        }
        this.visible = false
        this.promise.resolve(true)
      }
    }
  }
</script>
<style scoped lang='scss'>
  .mask {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .app-confirm {
    position: fixed;
    display: inline-block;
    left: 50%;
    top: 50%;
    width: 300px;
    border-radius: 4px;
    background-color: $color-white;
    text-align: center;
    transform: translate(-50%, -50%);
    > div {
      &:first-child {
        font-size: 16px;
        line-height: 40px;
        padding: 10px 0;
      }
      &:last-child {
        display: flex;
        border-top: $style-border;
        > a {
          flex: 1;
          text-align: center;
          line-height: 44px;
          font-size: 16px;
          &:first-child {
            color: $secondly-text-color;
          }
          &:last-child {
            color: $color-blue;
            border-left: $style-border;
          }
        }
      }
    }
  }

  .confirm-scale-enter-active, .confirm-scale-leave-active {
    transition: all 0.1s linear;
  }

  .confirm-scale-enter, .confirm-scale-leave-to {
    transform: translate(-50%, -50%) scale(0.3, 0.3);
  }
</style>



// WEBPACK FOOTER //
// AppConfirm.vue?4a55f6be